import React from 'react'
import TraderTitleBar from '../../features/trader/components/TraderTitleBar'
import TraderTable from '../../features/trader/components/TraderTable'

function TraderListPage() {
  return (
    <>
      <TraderTitleBar />
      <TraderTable />
    </>
  )
}

export default TraderListPage
